import IntelligentCargoLogo from './IntelligentCargoLogo'

export default IntelligentCargoLogo
